<template lang="pug">
    article.home

        include ../assets/svg/symbols

        Ui(
            :articles='articles',
            :articleActive.sync='articleActive',
            :articleActive='articleActive',
            :articlesOnScreen='isArticlesOnScreen',
            v-on:scrollToArticles='scrollToArticlesTop'
            )

        Intro(
            :heading='heading',
            v-on:clicknexttrigger='scrollToSelector'
            )

        .home__selector(
            ref='selector'
            )
            Selector(
                :articles='articles',
                :lead='lead',
                :articleActive.sync='articleActive',
                :articleActive='articleActive',
                v-on:scrollToArticles='scrollToArticlesTop'
            )

        .home__articles(
            v-observe-visibility='{callback: visibilityChanged, throttle: 300}',
            ref='articles'
            )

            Article(
                v-for='(article, name) in articles',
                :articledata='article',
                :footnote='footnote',
                :name='name',
                :key='name',
                :articleActive.sync='articleActive',
                :articleActive='articleActive',
                v-on:scrollToArticles='scrollToArticlesTop'
                v-show='name === articleActive'
                )

</template>

<script>
const Intro = () => import('@/components/Intro.vue');
const Selector = () => import('@/components/Selector.vue');
const Article = () => import('@/components/Article.vue');
const Ui = () => import('@/components/Ui.vue');

import {heading, lead, articles, footnote} from '@/assets/data/data';

export default {
    name: 'Home',

    components: {
        Intro,
        Selector,
        Article,
        Ui
    },

    data() {
        return {
            heading,
            lead,
            articles,
            footnote,
            articleActive: 'firststeps',
            isArticlesOnScreen: false
        };
    },

    watch: {
        articleActive(res) {
            this.$analytics.sendEvent({
                event: 'eventTracking',
                category: 'Event',
                action: 'change',
                label: `Article to ${res}`
            });
        }
    },

    methods: {
        scrollToSelector() {
            this.$scrollTo(this.$refs.selector);
        },

        scrollToArticlesTop() {
            this.$scrollTo(this.$refs.articles);
        },

        visibilityChanged(isVisible) {
            this.isArticlesOnScreen = isVisible;
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';

.home {
    position: relative;
    height: auto;

    @media (--viewport-tablet) {
        width: 100vw;
        overflow: hidden;
    }
}
</style>
